<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
          <div class="modal-content p-2">
            <div class="modal-header">
              <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" v-if="loading == false">
              <div class="maheading_2">
                <h5 class="modal-title"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-qr-code w-5 h-5 text-[#00ACEE]" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:107:12" data-component-name="QrCode"><rect width="5" height="5" x="3" y="3" rx="1"></rect><rect width="5" height="5" x="16" y="3" rx="1"></rect><rect width="5" height="5" x="3" y="16" rx="1"></rect><path d="M21 16h-3a2 2 0 0 0-2 2v3"></path><path d="M21 21v.01"></path><path d="M12 7v3a2 2 0 0 1-2 2H7"></path><path d="M3 12h.01"></path><path d="M12 3h.01"></path><path d="M12 16v.01"></path><path d="M16 12h1"></path><path d="M21 12v.01"></path><path d="M12 21v-1"></path></svg> Create Invitation</h5>
                <p class="mm-desc">
                  Pick the account, pathway, and step, then set a password. We'll generate
									a password-protected invitation link and QR code that drops the mentee
									into exactly the right place.
                </p>
              </div>
							<div class="mm-body">
								<template v-if="created">
									<InvitationQRDisplay
										:invitation="created"
										:base-path="basePath"
									/>
									<button type="button" class="mm-btn mm-btn--outline mm-btn--full" @click="createAnother">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InviteMenteeSheet.tsx:87:16" data-component-name="ArrowLeft"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg> <span>Create another invitation</span>
									</button>
								</template>

								<template v-else>
									<InvitationFields
										v-model="draft"
										:locations="locations"
										:locationType="locationType"
										:defaultLocationId="defaultLocationId"
										id-prefix="create"
									/>
									<button v-if="submitting == true"
										type="button"
										class="mm-btn mm-btn--orange mm-btn--full"
										:disabled="(!isComplete)"
										@click="generate"
									>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/InviteMenteeSheet.tsx:100:16" data-component-name="Plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg> <span>Generate invitation &amp; QR</span>
									</button>
									<p v-if="!isComplete" class="mm-foot">
										Choose an account, pathway, step, and password to continue.
									</p>
								</template>
							</div>

            </div>
            <div class="modal-footer mb-5"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import InvitationQRDisplay from "./InvitationQRDisplay.vue";
import InvitationFields from "./InvitationFields.vue";
import { notify } from "../../toastStore";

function emptyDraft() {
  return {
    locationId: "",
    locationName: "",
    pathwayId: "",
    pathwayName: "",
    stepId: "",
    stepName: "",
    password: genPassword(),
  };
}

export default {
  name: "InviteMenteeSheet",
	props: ['isModalVisible', 'locations', 'locationType', 'defaultLocationId'],
  components: { InvitationFields, InvitationQRDisplay },

  data() {
    return {
      draft: {
				locationId: "",
				locationName: "",
				pathwayId: "",
				pathwayName: "",
				stepId: "",
				stepName: "",
				password: Math.random().toString(36).slice(2, 8).toUpperCase(),
			},
      created: null,
			loading: false,
			invite: [],
      submitting: true,
    };
  },
  computed: {
    isComplete() {
      const d = this.draft;
      return !!d.pathwayId && !!d.stepId && !!d.password.trim();
    },
  },

  methods: {
		hide() {
			this.$emit('close');
		},
		loadInitialData() {
      this.draft = {
				locationId: "",
				locationName: "",
				pathwayId: "",
				pathwayName: "",
				stepId: "",
				stepName: "",
				password: Math.random().toString(36).slice(2, 8).toUpperCase(),
			};
      this.created = null;
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 100); 
		},
    genPassword() {
      return Math.random().toString(36).slice(2, 8).toUpperCase();
    },
    generate() {
      this.submitting = false;
      axios('/create-new-invitation',
				{
					method: 'POST',
					data:
					{
						accountId: this.$store.state.user_accountid,
						pathwayId: this.draft.pathwayId,
						stepId: this.draft.stepId,
						passcode: this.draft.password,
						locationId: this.draft.locationId,
					},
				}
			)
      .then((resp) => {
        this.submitting = true;
				this.created = resp.data;
        notify({
          title: "Invitation created",
          description: "Saved to Manage Invites. QR code and link are ready.",
        });
			})
      .catch(error => {

      });

		},
    createAnother() {
      this.draft = {
				locationId: "",
				locationName: "",
				pathwayId: "",
				pathwayName: "",
				stepId: "",
				stepName: "",
				password: Math.random().toString(36).slice(2, 8).toUpperCase(),
			};
      this.created = null;
    },
	},
}
</script>
<style scoped>
.back_icon { width: 14px; }
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in { 0% { -webkit-transform: translateX(100%);} 100% { -webkit-transform: translateX(0%);} }
@-webkit-keyframes slide-in { 0% { transform: translateX(100%);} 100% { transform: translateX(0%);} }
.modal-dialog { max-width: 90%; }
@media (min-width: 992px) { .modal-lg, .modal-xl { width: 700px; } }
@media (max-width: 576px){ .modal-dialog.modal-dialog-slideout { width: 80% } }
.modal-dialog-slideout { min-height: 100%; margin: 0 0 0 auto; background: #fff; }
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.maheading_2 { width: 75%; }
.subscription_box { border: 1px solid #e6e6e6; }
.ma-orange-btn { background-color: #f26422; color: #fff; border: none; }
.invite-card { background: #fff; border: 1px solid #ececec; }
.text-\[\#00ACEE\] {
    color: #00ACEE;
}
.modal-title {
  font-size: 1.125rem;
  color: #002F42;
  font-weight: 600;
  margin-bottom: 10px;
}
.mm-desc {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7785;
}
.mm-create {
  margin-top: 24px;
}
.mm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.mm-btn--sm {
  height: 32px;
  padding: 0 10px;
  font-size: 13px;
}
.mm-btn--full {
  width: 100%;
}
.mm-btn--orange {
  background: #ee4200;
  color: #fff;
  border-color: hsl(from hsl(197 100% 47%) h s calc(l + -8) / alpha);
  font-weight: 600;
  margin-block-end: calc(calc(0.25rem * 5) * calc(1 - 0));
}
.mm-btn--orange:hover {
  background: #cc3800;
}
.mm-btn--blue {
  background: #00acee;
  color: #fff;
}
.mm-btn--blue:hover {
  background: #0095d0;
}
.mm-btn--outline {
  background: #fff;
  border-color: #d6dde1;
  color: #1f2a30;
}
.mm-btn--outline:hover {
  background: #f3f5f6;
}
.mm-btn--danger {
  background: #fff;
  border-color: rgba(238, 66, 0, 0.3);
  color: #ee4200;
}
.mm-btn--danger:hover {
  background: rgba(238, 66, 0, 0.1);
}
.mm-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mm-empty {
  border: 1px dashed #d6dde1;
  border-radius: 12px;
  background: rgba(0, 47, 66, 0.02);
  padding: 32px;
  text-align: center;
  color: #6b7785;
  font-size: 14px;
}
.mm-empty-icon {
  color: #c3ccd1;
  display: block;
  margin: 0 auto 12px;
}
.mm-card {
  border: 1px solid #e4e9ec;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mm-card--edit {
  background: rgba(0, 47, 66, 0.03);
  gap: 16px;
}
.mm-card-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #002f42;
}
.mm-card-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.mm-card-info {
  min-width: 0;
}
.mm-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 0;
  font-size: 12px;
  color: #6b7785;
}
.mm-muted-icon {
  color: #6b7785;
}
.mm-date {
  font-size: 11px;
  color: #6b7785;
  white-space: nowrap;
}
.mm-actions {
  display: flex;
  gap: 8px;
}
.mm-wrap {
  flex-wrap: wrap;
}
.mm-grow {
  flex: 1 1 auto;
}
.mm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.mm-foot {
  margin: 0;
  font-size: 12px;
  color: #6b7785;
  text-align: center;
}
.mm-body {
  margin-top: calc(0.25rem * 6);
}
</style>


// WEBPACK FOOTER //
// src/components/manager/create_invite.vue